/* app/js/src/components/quality-check/quality-check.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: hidden;
  overflow-x: hidden;
}
.main-container {
  height: 100%;
  padding: 13px 22px 15px 32px;
}
ngx-datatable {
  width: 100%;
}
ngx-datatable ngx-datatable-footer {
  height: 50px;
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-text {
  color: #232f3a;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
}
.back-to-scheduler-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.back {
  color: #232f3a;
  font-family: "Open Sans";
  font-size: 10px;
  margin-right: 10px;
}
.rounded-btn-prev {
  width: 28px;
  height: 28px;
  background-color: #f1f3f4;
  border-radius: 4px;
  text-align: center;
  padding-top: 7px;
  padding-right: 2px;
}
.table-header {
  display: flex;
  margin-top: 15px;
  margin-bottom: -21px;
  color: #232f3a;
}
.table-header .alert-count-header {
  margin-right: 8px;
}
.table-header .alert-count {
  color: #879baf;
}
.approve-all-button:hover input[type=checkbox]:before {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
  height: 0.5rem;
  border-color: #232f3a;
  border-top-style: none;
  border-right-style: none;
}
.media-info-container {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
}
.media-info-container h2 {
  font-size: 1.5em;
  margin: 0;
  margin-bottom: 12px;
  font-weight: 400;
}
.media-info-container .media-container {
  min-height: 225px;
  width: 300px;
  position: relative;
  flex-grow: 1;
}
.column {
  display: flex;
  flex-direction: column;
}
.label-header {
  color: #879baf;
  font-family: "Open Sans";
  font-size: 12px;
  margin-right: 5px;
}
.labels-container {
  margin-bottom: 8px;
}
.label-content {
  color: #232f3a;
  font-family: "Open Sans";
  font-size: 12px;
}
.label-content-status {
  color: #232f3a;
  font-family: "Open Sans";
  font-size: 13px;
  font-weight: bold;
}
.severity {
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  border-radius: 25px;
  width: 100px;
  height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 14px 0;
}
.severity-low {
  color: #61b965;
  background-color: #deeedf;
}
.severity-medium {
  color: #ce8306;
  background-color: #f9f0cf;
}
.severity-high {
  color: #ef5350;
  background-color: #f7dbdb;
}
.description-ellipsis {
  width: 350px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=quality-check.css.map */
